import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    class: "GoToForgotPassword",
    "data-cy": "GoToForgotPassword",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToForgotPassword && _ctx.goToForgotPassword(...args)), ["prevent"]))
  }, "Forgot password"))
}